<template>
    <div class="left-select">
        <div class="left-select-con">
            <div class="left-select-item cruise-order-item" @click="setOrderByValue('orderBysailDate')">
                <span>出发时间</span>
                <img style="margin-left: 5px;" class="sort-image sort-default" v-show="currentOrderBy('orderBysailDate') == 0"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-def.jpg">
                <img class="sort-image sort-up" style="margin-left: 5px" v-show="currentOrderBy('orderBysailDate') == 1"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-up.jpg">
                <img class="sort-image sort-down" style="margin-left: 5px;" v-show="currentOrderBy('orderBysailDate') == 2"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-down.png">
            </div>
            <div class="left-select-item cruise-order-item" @click="setOrderByValue('orderByPrice')">
                <span>人均起价</span>
                <img style="margin-left: 5px" class="sort-image sort-default" v-show="currentOrderBy('orderByPrice') == 0"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-def.jpg">
                <img class="sort-image sort-up" style="margin-left: 5px;" v-show="currentOrderBy('orderByPrice') == 2"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-up.jpg">
                <img class="sort-image sort-down" style="margin-left: 5px;" v-show="currentOrderBy('orderByPrice') == 1"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-down.png">
            </div>
            <div class="left-select-item cruise-order-item" @click="setOrderByValue('orderByAmountPerNight')">
                <span>人均每晚价格</span>
                <img style="margin-left: 5px" class="sort-image sort-default" v-show="currentOrderBy('orderByAmountPerNight') == 0"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-def.jpg">
                <img class="sort-image sort-up" style="margin-left: 5px;" v-show="currentOrderBy('orderByAmountPerNight') == 2"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-up.jpg">
                <img class="sort-image sort-down" style="margin-left: 5px;" v-show="currentOrderBy('orderByAmountPerNight') == 1"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-down.png">
            </div>
            <div class="left-select-item cruise-order-item" @click="setOrderByValue('orderByPopular')">
                <span>人气度</span>
                <img style="margin-left: 5px" class="sort-image sort-default" v-show="currentOrderBy('orderByPopular') == 0"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-def.jpg">
                <img class="sort-image sort-up" style="margin-left: 5px;" v-show="currentOrderBy('orderByPopular') == 2"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-up.jpg"> 
                <img class="sort-image sort-down" style="margin-left: 5px;" v-show="currentOrderBy('orderByPopular') == 1"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-sort-down.png">
            </div>
        </div>
        <div class="left-select-con"
            style="border-left: 1px dashed #d3dadd; padding-left: 20px;float: right;">
            <div class="check-item-con check-item-con-mode" :class="{ active: isShowAgencyCruise}" @click="onShowAgencyClicked">
                <img class="float-left selected-icon tripCheckbox" style="margin-right: 6px"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon tripCheckbox" style="margin-right: 6px"
                    src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <div class="float-left">显示已售完及包船航次</div>
            </div>

            <span class="price-des" @click="showCruisePricePopup">价格说明?</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "CruiseSearchOrderBy",
    props: {
        cruiseFilters: {
            type: Array,
            default () {
                return []
            }
        },
        initSelectFilterCodes: {
            type: Object,
            default () {
                return {}
            }
        },
        orderByConfirmHandler: {
            type: Function
        },
        showAgencyHandler: {
            type: Function
        }
    },
    beforeMount () {
        this.initFilterData(this.initSelectFilterCodes)
    },
    data () {
        return {
            selectFilterCodes: {
                orderBysailDate: 1,
                orderByPrice: 0,
                orderByPopular: 0,
                orderByAmountPerNight: 0
            },
            isShowAgencyCruise: false
        }
    },
    methods: {
        // 初始化选中的条件
        initFilterData (initFilters) {
            let filters = {}
            Object.keys(initFilters).forEach((key) => {
                if (key.indexOf('orderBy') >= 0) {
                    const value = parseInt(initFilters[key])
                    if (!isNaN(value)) {
                        filters[key] = parseInt(initFilters[key])
                    }
                }
            })
            this.selectFilterCodes = filters
        },
        setOrderByValue (key) {
            let defaultOrderBy = this.getDefaultOrderBy()
            let currentValue = this.currentOrderBy(key) + 0
            if (currentValue == 1) {
                currentValue = 2
            } else if (currentValue == 2) {
                currentValue = 1
            } else if (currentValue == 0) {
                if (key == 'orderBysailDate') {
                    currentValue = 1
                } else {
                    currentValue = 2
                }
            }
            this.selectFilterCodes = defaultOrderBy
            this.selectFilterCodes[key] = currentValue
            this.orderByConfirmHandler(this.selectFilterCodes)
        },
        currentOrderBy (key) {
            return this.selectFilterCodes[key]
        },
        getDefaultOrderBy () {
            return {
                orderBysailDate: 0,
                orderByPrice: 0,
                orderByPopular: 0,
                orderByAmountPerNight: 0
            }
        },
        onShowAgencyClicked () {
            this.isShowAgencyCruise = !this.isShowAgencyCruise
            this.showAgencyHandler(this.isShowAgencyCruise)
        },
        showCruisePricePopup () {
            this.$emit('showCruisePricePopup')
        }
    },
    watch: {
        
        initSelectFilterCodes (newOne) {
            this.initFilterData(newOne)
        }
    }
}
</script>

<style lang="less" scoped>
.left-select {
    background-color: #fff;
    height: 45px;
    padding: 10px 25px;
    margin-bottom: 10px;
    .left-select-con {
        float: left;
        line-height: 25px;
        .left-select-item {
            float: left;
            margin-right: 35px;
            line-height: 25px;
        }
    }
    .check-item-con {
        margin-top: 0;
        margin-bottom: 0;
    }

    .cruise-order-item {
        cursor: pointer;
        .tripCheckbox {
            position: relative;
            top: 3px;
        }
        
    }
    .check-item-con {
        margin-right: 25px;
        float: left;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        .selected-icon {
           display: none;
        }
        .unselected-icon {
            display: block;
        }
    }

    .check-item-con.active {
        .selected-icon {
            display: block;
        }
        .unselected-icon {
           display: none;
        } 
    }
    .price-des {
        font-size: 12px;
        text-decoration: underline;
        color: #4a90e2;
        cursor: pointer;
    }
}

</style>